import React, { useEffect, useState } from 'react';
import './index.css';
import LcLoading from '../LcLoading';
import GenerativeIaEvaluationService from '../../../services/GenerativeIaEvaluationService/GenerativeIaEvaluationService';
import LcIconLink from "../../Generic/LcIconLink";
import Parse from 'html-react-parser';
import ContentEditable from 'react-contenteditable';
import moment from 'moment';
import AlertNotification, { AlertColor } from '../../Dialog/AlertNotification';
import LcAccordion from '../LcAccordion';
import AixCompanySevice from '../../../services/AixCompanyService/AixCompanyService';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import TextTools from '../../../services/TextTools/TextTools';
import { CommentNotificationState, commentNotificationReducer } from '../../../store/reducers/commentNotificationReducer,';

interface Props {
    title?: string;
    originalText: string;
    visible: boolean;
    handleVisible: Function;
    setText: Function;
    user: any;
    solicitation: any;
    conclusion?: Boolean;
    summarization?: boolean;
    summary?: any;
    reload?: boolean;
    withOriginalText?: boolean;
    instructionType?: number;
    auxProps?: { [key: string]: any }; // Add this line to include auxProps
}

const HHContentAI: React.FC<Props> = (props) => {
    const generativeIaEvaluationService = new GenerativeIaEvaluationService(props);
    const AixCompany = new AixCompanySevice(props);
    const commentNotification = useSelector<RootState, CommentNotificationState>(state => state.commentNotificationReducer);

    const [loadingSugggestion, setLoadingSugggestion] = useState<boolean>(false);
    const [originalTextVisible, setOriginalTextVisible] = useState<boolean>(false);
    const [editable, setEditable] = useState<boolean>(false);
    const [totalTokens, setTotalTokens] = useState<number>(0);
    const [suggestion, setSuggestion] = useState<string>("");
    const [message, setMessage] = useState<string>("");
    const [severity, setSeverity] = useState<AlertColor>("info");
    const [openNotificacao, setOpenNotificacao] = useState<boolean>(false);
    const [summary, setSummary] = useState<any>();
    const [summaryText, setSummaryText] = useState<string>("");
    const dispatch = useDispatch();
    const textTools = new TextTools();

    const getFormatedAuxProps = () => {
        try {
            if (!props.auxProps) {
                return '';
            }

            return Object.entries(props.auxProps)
                .map(([key, value]) => `${value}`)
                .join('\n');
        }
        catch (e) {
            return "";
        }
    }

    useEffect(() => {
        if (props.solicitation && ((commentNotification[props.solicitation.id] && ((commentNotification[props.solicitation.id].visible) || commentNotification[props.solicitation.id]?.reloadSumary)))) {
            if (props.summarization) {
                setNewSummary(props.solicitation.id, props.user.id);
            }
            else {
                if (props.instructionType) {
                    getInquireWithInstruction(props.instructionType);
                }
                else {
                    getSugestion();
                }
            }
        }
        else if (props.visible) {
            if (props.summarization) {
                getSummary(props.solicitation.id);
            }
            else {
                if (props.instructionType) {
                    getInquireWithInstruction(props.instructionType);
                }
                else {
                    getSugestion();
                }
            }
        }
        setEditable(false);
    }, [props.visible, props.reload, props.solicitation]);

    const getInquireWithInstruction = async (Instruction) => {
        setLoadingSugggestion(true);

        try {
            var auxData = "";

            var textToSend = textTools.cleanText(props.originalText);

            if (textToSend) {
                if (Instruction == 1) {
                    try {
                        auxData = getFormatedAuxProps();
                    }
                    catch (e) {
                        console.log(e);
                    }
                }
                if (auxData != "" && auxData) {
                    // textToSend = textTools.cleanText(auxData) + " " + textTools.cleanText(props.originalText);
                    textToSend = textTools.cleanText(auxData);
                }
            }

            let response = props.instructionType && await AixCompany.GetInquireWithInstruction(textToSend, props.instructionType, props.user.nickName || '', 492)
            setSuggestion(response.message)
        }
        catch (error) {
            console.error(error)
        }

        setLoadingSugggestion(false);
    }

    const getSummary = async (solicitationId: number) => {
        setLoadingSugggestion(true);

        try {
            const response = await generativeIaEvaluationService.GetGenerativeIaEvaluationList(solicitationId);
            var commentSummary = response.data.filter(x => x.recordType == 1);

            if (commentSummary.length > 0) {
                var textString = JSON.stringify(commentSummary[0].text).replaceAll("\\n", "<br>");
                var _text = JSON.parse(textString);
                setSummaryText(_text);
                setSummary(commentSummary[0]);
                setEditable(false)
            }
            else {
                await setNewSummary(props.solicitation.id, props.user.id);
            }
        }
        catch (error) {
            console.error(error)
        }

        // if (commentNotification[solicitationId]?.visible) {
        dispatch({
            type: 'HideNotification',
            payload: {
                idSolicitation: solicitationId,
                oldAmountOfComments: commentNotification[solicitationId].numberOfComments,
                sumarization: true,
            }
        });
        // }

        setLoadingSugggestion(false);
    }

    const setNewSummary = async (solicitationId: number, IdUser: number) => {
        setLoadingSugggestion(true);

        try {
            var solicitationSumarizeRequest = {
                idSolicitation: solicitationId,
                idUser: IdUser,
                recordType: 1,
            }
            await generativeIaEvaluationService.SetCommentSummary(solicitationSumarizeRequest);
            await getSummary(solicitationId);
        }
        catch (error) {
            console.error(error)
        }

        // setLoadingSugggestion(false);
        dispatch({
            type: 'ShowNotification',
            payload: {
                visible: false,
                idSolicitation: props.solicitation.id,
                sumarization: true,
                reloadSumary: false

            }
        });
    }

    const saveNewSummary = async () => {
        setLoadingSugggestion(true);

        try {
            const _summary = {
                ...summary,
                Prompt: summaryText
            }

            await generativeIaEvaluationService.SetNewCommentSumary(_summary);
            await getSummary(props.solicitation.id);
        }
        catch (error) {
            console.error(error)
        }

        setLoadingSugggestion(false);
    }
    const getSugestion = async () => {
        setLoadingSugggestion(true);

        try {
            const requestObj = {
                IdSolicitation: (props.solicitation) ? props.solicitation.id : 0,
                IdUser: props.user.id,
                Prompt: props.originalText
            }

            const response = (props.conclusion)
                ? await generativeIaEvaluationService.GetExpandedSuggestionConclusion(requestObj)
                : await generativeIaEvaluationService.GetExpandedSuggestion(requestObj);

            var content = response.data.responseOpenAI.choices[0].message.content;
            setTotalTokens(response.data.responseOpenAI.usage.total_tokens);

            var textString = JSON.stringify(content).replaceAll("\\n", "<br>");
            var _text = JSON.parse(textString);

            setSuggestion(_text);
        }
        catch (error) {
            console.error(error);
        }

        setLoadingSugggestion(false);
    }

    const copyToClipbord = () => {
        var textString = JSON
            .stringify(suggestion)
            .replaceAll("<br>", "\\n")
            .replaceAll("<br />", "\\n")
            .replaceAll("<br/>", "\\n");
        var _text = JSON.parse(textString);
        navigator.clipboard.writeText(_text);
        setMessage(`Texto copiado com sucesso`);
        setSeverity("success");
        setOpenNotificacao(true);
        setTimeout(() => setOpenNotificacao(false), 2000);
    };

    const handleDisable = () => {
        setEditable(!editable);
        var textString = JSON.stringify(summary.text).replaceAll("\\n", "<br>");
        var _text = JSON.parse(textString);
        setSummaryText(_text);
    }

    const texts: string[] = [
        'Texto personalizado', // default case
        'Texto elaborado',
        'Texto reduzido',
        'Texto expandido',
        'Texto formalizado',
        'Texto corrigido',
        'Texto comunicativo',
        'Texto bem-humorado',
        'Texto entusiasmado',
        'Texto informativo',
        'Texto profissional',
        'Texto inteligente',
        'Texto confiável'
    ];

    const getTextByInstruction = (instruction: number): string => {
        return texts[instruction] || texts[0];
    };

    return (
        <>
            <AlertNotification open={openNotificacao} severity={severity} message={message} handleClose={() => setOpenNotificacao(false)} />
            {
                props.withOriginalText &&
                <div style={{ backgroundColor: '#ECF0FD', padding: '10px 20px', borderRadius: '3px' }}>
                    <LcAccordion iconNormal={true} customFontSize="12px" title={"Texto original:"} visible={originalTextVisible} onChange={setOriginalTextVisible}>
                        <div className={`originalText disabled`} id="originalText" dangerouslySetInnerHTML={{ __html: props.originalText }} />
                    </LcAccordion>
                </div>
            }
            <div className={`allAI  ${(props.visible) ? "open " : ""}`} >
                <div className={`contentAI borderAI ${props.visible ? "open " : ""}`}>
                    <LcLoading label={"Carregando ..."} loading={loadingSugggestion}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <div className={" row title-sugestao"}>
                                <i className="ppi ppi-lightning-bolt ppi-2x" />
                                <p style={{ marginLeft: "-5px" }}>
                                    {
                                        (props.summarization)
                                            ? "Resumo do chamado"
                                            : (props.instructionType)
                                                ? getTextByInstruction(props.instructionType)
                                                : "Sugestão expandida"
                                    }
                                </p>
                            </div>
                        </div>
                        {
                            (props.summarization === undefined || !editable)
                                ? <p className="AiText" id="AiText" style={{ minHeight: "50px" }}>{(props.summarization) ? Parse(summaryText) : Parse(suggestion)}</p>
                                : <ContentEditable
                                    html={props.summarization ? summaryText : suggestion}
                                    className={"AiText sumarization scrollable-v "}
                                    style={{ maxHeight: '150px' }}
                                    id={"AiText"}
                                    onChange={(e) => {
                                        var textString = JSON.stringify(e.target.value).replaceAll("\\n", "<br>");
                                        var _text = JSON.parse(textString);
                                        setSummaryText(_text);
                                    }} />
                        }
                        <div className="action-wrapper">
                            <div className="row">
                                <LcIconLink
                                    tooltipPosition="right"
                                    size='small'
                                    icon="ppi ppi-duplicate"
                                    tooltip={"Copiar texto"}
                                    onClick={() => copyToClipbord()}
                                />
                                <LcIconLink
                                    tooltipPosition="right"
                                    size='small'
                                    icon={"ppi ppi-refresh"}
                                    tooltip={props.summarization ? 'Gerar novo sumário' : "Nova sugestão"}
                                    onClick={() => {
                                        if (props.summarization) {
                                            dispatch({
                                                type: 'ShowNotification',
                                                payload: {
                                                    visible: false,
                                                    idSolicitation: props.solicitation.id,
                                                    sumarization: true,
                                                    reloadSumary: true
                                                }
                                            })
                                        }
                                        else {
                                            if (props.instructionType) {
                                                getInquireWithInstruction(props.instructionType);
                                            }
                                            else {
                                                getSugestion();
                                            }
                                        }
                                    }}
                                />
                            </div>
                            {
                                props.summarization !== undefined
                                    ? <>
                                        {
                                            !editable
                                                ? <div
                                                    style={{
                                                        fontSize: "12px",
                                                        color: "grey",
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        alignItems: "flex-end",
                                                    }}>
                                                    <span style={{ fontWeight: 300, width: '300px', textAlign: 'end' }}>Gerado em {moment(summary && summary.generatedDate).format("DD/MM/YYYY - HH:mm")} por {summary && summary.nameUser}</span>
                                                </div>
                                                : <button className={"lc-button bg-info"} onClick={() => saveNewSummary()}>Salvar Alterações</button>
                                        }
                                    </>
                                    : <button
                                        className={"lc-button bg-info"}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            props.handleVisible(false);
                                            props.setText(suggestion);
                                        }}
                                    >Usar esse texto</button>
                            }
                        </div>
                    </LcLoading>
                </div>
            </div>
        </>
    )
}

export default HHContentAI;
